import { combineReducers } from "redux";
import recommendationsReducer from "./profileRecommendations.reducer";

export default combineReducers({
  profileRecommendations: recommendationsReducer,
});
